
export default {
    name: 'IconAddressDirectory',
    props: {
        width: {
            type: String,
            default: '24.615px'
        },
        height: {
            type: String,
            default: '24.446px'
        },
        color: {
            type: String,
            default: '#303030'
        }
    }
}
